export const DEFAULT_JOBS = ["مامۆستا", "پزیشک", "ئەندازیار", "بازرگان", "فەرمانبەر", "کرێکار", "خوێندکار"];
